<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'customerManage-selectionTracking',
  components: {
    PageTable,
  },
}
</script>
